import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {Button} from '@stubhub/bamboo';

// CSS
import './index.scss';

const NoTicketsAvailable = ({className = '', svgImage, headerText, children, buttonText, onClick, href}) => {
  return (
    <section className={`NoTicketsAvailable__content ${className}`}>
      {svgImage}
      {headerText && <h1 className="NoTicketsAvailable__header">{headerText}</h1>}
      {children && <p className="NoTicketsAvailable__middle">{children}</p>}
      {buttonText && (
        <Button
          href={href}
          className={classNames('NoTicketsAvailable__button', {className: `${className}__button`})}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      )}
    </section>
  );
};

NoTicketsAvailable.propTypes = {
  /** The Class Name used to override the Styling for the component. */
  className: PropTypes.string,

  /** Svg image */
  svgImage: PropTypes.element,

  /** Text for the main header */
  headerText: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),

  /** Content of the button */
  buttonText: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),

  /** Callback function to invoke when button/link is clicked */
  onClick: PropTypes.func,

  /** (optional) Href for the link */
  href: PropTypes.string,

  /** Middle content */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
};

export default NoTicketsAvailable;
